import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5a986796"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=5a986796&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.0__lodash@4.17.23_igavytiafgosz6q2bphdaa3wbq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports